import Vue from 'vue'
import Router from 'vue-router'
// import iView from 'iview'
import { getToken } from '@/libs/util'
import routes from './routers'
import Store from '@/store'
Vue.use(Router)
const router = new Router({
  mode: 'history',
  routes
})
let noLogin = ['login', 'forget', 'modify', '*']
let expertPage = ['cv-rl-cv-expert', 'cv-rl-rl-expert', 'project-expert-modify']
router.beforeEach(async (to, from, next) => {
  // iView.LoadingBar.start()
  let token = getToken()
  if (!token && !noLogin.includes(to.name)) {
    next({
      name: 'login'
    })
  } else if (token && to.name === 'login') {
    next({
      name: from.name
    })
  } else {
    let product = localStorage.getItem('product')
    let path = to.path
    if (noLogin.includes(to.name)) {
      return next()
    }
    if (product === 'UNDERGRADUATE') {
      if (path.includes('undergraduate')) {
        next()
      } else {
        next({
          name: 'undergraduate-home'
        })
      }
    } else if (product === 'MASTER') {
      if (path.includes('undergraduate')) {
        next({
          name: 'home'
        })
      } else {
        // 判断是否有专家的权限
        let userInfo = Store.state.user.userInfo
        if (!Object.keys(userInfo).length) {
          userInfo = await Store.dispatch('getInfoDetail')
        }
        if (
          expertPage.includes(to.name) &&
          !(userInfo.packageInfo && userInfo.packageInfo.expertCount)
        ) {
          next({
            name: 'home'
          })
        } else {
          next()
        }
      }
    }
  }
})
router.afterEach(() => {
  // iView.LoadingBar.finish()
  window.scrollTo(0, 0)
})
export default router
